import React, {useState} from 'react';
import './index.css';

import goBack from './resources/controls/left.png';
import fastForward from './resources/controls/right.png';
import {AVAILABLE_BODIES, AVAILABLE_FACES, AVAILABLE_HAIRSTYLES} from "./assets";
import { HexagonalColorHue, HexagonalColorPicker } from "react-hexagon-color-picker";

export function AvatarBuilder({bodyIndex, setBodyIndex, faceIndex, setFaceIndex, hairIndex, setHairIndex, customClothesColor, setCustomHairColor, customSkinColor, setCustomSkinColor, setCustomClothesColor, customHairColor}) {

    const [changingColorIndex, setChangingColorIndex] = useState(-1)

    function changeColor(color) {
        if (changingColorIndex === 0) {
            setCustomHairColor(color)
        } else if (changingColorIndex === 1) {
            setCustomSkinColor(color)
        } else if (changingColorIndex === 2) {
            setCustomClothesColor(color)
        }
    }

    function getCustomColor(index) {
        if (index === 0) {
            return customHairColor
        } else if (index === 1) {
            return customSkinColor
        } else if (index === 2) {
            return customClothesColor
        }
    }


    function buildComponentSelector(indexArray, setIndexArray, availableComponents, index, imageStyle = {}, controlsStyle={}) {
        const MyComponent = availableComponents[indexArray]
        return <>
            <button style={{
                ...controlsStyle, cursor: "pointer",
                marginTop: index === 1 ? "100px" : "0px",
                paddingTop: "0px",
                width: "150px",
                borderRadius: "20px",
                letterSpacing: "1px",
                fontSize: "20px",
                height: "60px",
                backgroundColor: changingColorIndex === index ?  "#FD96BB" : "#F8D404",
                fontFamily: "PlanetKosmos",
            }}
            onClick={() => {
                setChangingColorIndex(index)
            }}> {changingColorIndex === index ? "Change Color" : "Change Color"} </button>
            <div style={{width: "33%", height: "100%", display: "flex", paddingLeft: "30px", paddingRight: "30px", cursor: "pointer", alignItems: "end"}}>
                <img style={controlsStyle} src={goBack} alt="Logo"
                     onClick={() => setIndexArray(prev => prev <= 0 ? availableComponents.length - 1 : prev - 1)}/>
            </div>
            <div style={{height: "200px", display: "flex"}}>
                <MyComponent style={{...imageStyle, "--custom-color": getCustomColor(index), "--custom-skin-color": getCustomColor(1)}}/>
            </div>
            <div style={{width: "33%", height: "100%", display: "flex", paddingLeft: "30px", paddingRight: "30px", cursor: "pointer", alignItems: "end"}}>
                <img style={{...controlsStyle, marginLeft: "70px"}} src={fastForward} alt="Logo"
                     onClick={() => setIndexArray(prev => prev >= availableComponents.length - 1 ? 0 : prev + 1)}/>
            </div>
        </>;
    }

    return <div style={{width: "100%", display: "flex"}}>
        <div style={{width: "15%", height: "30%", paddingLeft: "50px", paddingRight: "20px"}}>
            {changingColorIndex !== -1 &&
                <HexagonalColorPicker onColorChange={changeColor}></HexagonalColorPicker>}
        </div>
        <div style={{width: "60%"}}>
            <div style={{
                height: "80px",
                marginBottom: "-30px",
                display: "flex",
                zIndex: 3, alignItems: "center"
            }}>
                {buildComponentSelector(hairIndex, setHairIndex, AVAILABLE_HAIRSTYLES, 0, {
                    width: "213px",
                    marginLeft: "-6px",
                    zIndex: 3,
                    marginBottom: hairIndex >= 2 ? "-235px" : "-175px",
                }, {height: "70px"})}
            </div>
            <div style={{height: "200px", display: "flex", marginTop: "30px", marginBottom: "-20px", zIndex: 2, alignItems: "end"}}>
                {buildComponentSelector(faceIndex, setFaceIndex, AVAILABLE_FACES, 1, {zIndex: 2}, {
                    height: "70px",
                })}
            </div>
            <div style={{height: "200px", display: "flex", zIndex: 1, alignItems: "end"}}>
                {buildComponentSelector(bodyIndex, setBodyIndex, AVAILABLE_BODIES, 2, {zIndex: 1}, {
                    height: "70px"
                })}
            </div>
        </div>
        <div style={{width: "30%"}}>
        </div>
    </div>;

}
